import "./_aboutMe.scss";
import image from "../../assets/images/gz.jpg";

import blob from "../../assets/images/blob.svg";
import Skills from "../skills";
import ProjectList from "../projectList";

function AboutMe() {
  return (
    <section className="about-me container" >
      <img src={blob} className="blob" alt="shape" />

      <div className="about-content">
        <div className="text">
          <h2>ABOUT ME</h2>
          <p>
          Soy un apasionado desarrollador de software en formación, tengo experiencia React y TypeScript. Estoy actualmente estudiando ingeniería de software y aprendiendo Node. Me encanta la programación y el diseño, y estoy siempre buscando nuevos proyectos y retos que me permitan mejorar mis habilidades y conocimientos. Si estás interesado en colaborar o tienes una oportunidad de trabajo que creas que podría ser un buen ajuste para mí, no dudes en ponerte en contacto conmigo.
          </p>
        </div>

        <div className="image">
          {/* <img
            src={image}
            className="blur"
            alt="Guillermo Zevallos"
            loading="lazy"
          /> */}
          <div className="blur"></div>
          <img
            src={image}
            className="picture"
            alt="Guillermo Zevallos"
            loading="lazy"
          />
        </div>
      </div>

      <Skills/>
      <ProjectList/>
    </section>
  );
}

export default AboutMe;
